import React, { useState, useEffect } from "react";
import Editor from "@monaco-editor/react";

export function JSONEditor({ label, value, onChange, height, language }) {
  const [editorValue, setEditorValue] = useState(value);
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setEditorValue(value);
  }, [value]);

  const handleEditorChange = (newValue) => {
    setEditorValue(newValue);
    validateJSON(newValue);
    onChange(newValue);
  };

  const validateJSON = (jsonString) => {
    try {
      JSON.parse(jsonString);
      setIsValid(true);
      setErrorMessage("");
    } catch (e) {
      setIsValid(false);
      setErrorMessage(e.message);
    }
  };

  function handleEditorDidMount(editor, monaco) {
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      validate: true,
      allowComments: false,
      schemas: [],
    });
  }

  return (
    <div className="mb-6">
      <label
        htmlFor="json-editor"
        className="block text-sm font-medium leading-6 text-gray-900 mb-2"
      >
        {label}
      </label>
      <div className="mt-1">
        <Editor
          height={`${height}px`}
          defaultLanguage={language || "json"}
          value={editorValue}
          onChange={handleEditorChange}
          onMount={handleEditorDidMount}
          options={{
            minimap: { enabled: false },
            lineNumbers: "on",
            roundedSelection: false,
            scrollBeyondLastLine: false,
            readOnly: false,
            theme: "vs-light",
            formatOnPaste: true,
            formatOnType: true,
          }}
          className="rounded-md p-1 border border-gray-300 shadow-sm"
        />
      </div>
      <div className="h-5 mt-2">
        {!isValid && (
          <div className="text-sm text-red-600">
            <span>JSON is invalid: </span>
            <span>{errorMessage}</span>
          </div>
        )}
      </div>
    </div>
  );
}
